const blogs = [
  {
    id: 1,
    date: "2024-12-18",
    picture: {
      avif: "img/b1.avif",
      webp: "img/b1.webp",
      jpg: "img/b1.jpg",
    },
    title: "Descubra os Melhores Jogos no etropg",
    descr:
      "Explore uma seleção incrível de jogos no etropg plataforma e aproveite momentos de pura diversão.",
    fullText:
      "O etropg oferece uma ampla variedade de jogos para todos os gostos. Desde slots emocionantes a jogos de cartas clássicos, há algo para todos.\n\nOs gráficos de alta qualidade garantem uma experiência imersiva que cativa desde o primeiro momento.\n\nOs bônus exclusivos do etropg tornam a experiência ainda mais gratificante, permitindo que você jogue mais e ganhe mais.\n\nA plataforma é completamente segura, protegendo suas informações pessoais e financeiras com tecnologia de ponta.\n\nAlém disso, o etropg é acessível de qualquer dispositivo, seja um computador, tablet ou smartphone.\n\nJogos como Fortune Tiger e Aviator são alguns dos favoritos entre os jogadores por sua jogabilidade única e prêmios incríveis.\n\nPara quem gosta de desafios, o etropg também oferece competições e torneios emocionantes.\n\nNão perca a chance de explorar tudo o que o etropg tem a oferecer. Inscreva-se agora e aproveite!",
  },
  {
    id: 2,
    date: "2024-12-15",
    picture: {
      avif: "img/b2.avif",
      webp: "img/b2.webp",
      jpg: "img/b2.jpg",
    },
    title: "5 Dicas para Aproveitar ao Máximo Seus Bônus",
    descr:
      "Saiba como tirar o máximo proveito dos bônus exclusivos disponíveis no etropg plataforma.",
    fullText:
      "Os bônus do etropg são projetados para oferecer mais oportunidades de ganhar. Veja como aproveitá-los ao máximo.\n\n1. Leia os termos e condições antes de ativar qualquer bônus para entender as exigências de apostas.\n\n2. Use seus bônus para explorar novos jogos e descobrir seus favoritos sem arriscar seu dinheiro.\n\n3. Combine bônus com promoções diárias para maximizar seus ganhos.\n\n4. Aproveite os bônus de boas-vindas ao fazer seu primeiro depósito e comece com vantagens.\n\n5. Seja estratégico e use seus bônus em jogos que oferecem altos retornos.\n\nOs bônus são uma excelente maneira de estender seu tempo de jogo e aumentar suas chances de ganhar.\n\nFique atento às atualizações do etropg para não perder nenhuma oferta especial.\n\nExperimente essas dicas e veja como seus ganhos podem crescer!",
  },
  {
    id: 3,
    date: "2024-12-10",
    picture: {
      avif: "img/b3.avif",
      webp: "img/b3.webp",
      jpg: "img/b3.jpg",
    },
    title: "Jogos Mais Populares de 2024 no etropg",
    descr:
      "Confira a lista dos jogos mais jogados no etropg e descubra por que eles são tão amados.",
    fullText:
      "1. Fortune Tiger: Com gráficos impressionantes e jogabilidade envolvente, este jogo continua a ser um dos favoritos.\n\n2. Aviator: Um jogo de estratégia onde o tempo é crucial. Aposte, retire seus ganhos e desafie a sorte.\n\n3. Super Slots: Explore temas incríveis e prêmios irresistíveis em uma experiência de slot de tirar o fôlego.\n\n4. Blackjack Master: Para os amantes de estratégia, este jogo é uma excelente opção para exercitar suas habilidades.\n\n5. Roleta Clássica: Um clássico que nunca sai de moda, perfeito para quem gosta de emoção pura.\n\nEstes jogos são apenas alguns exemplos do que você pode encontrar no etropg.\n\nA variedade e qualidade são garantidas para atender a todos os estilos de jogadores.\n\nNão importa o que você escolha, diversão e prêmios esperam por você no etropg.",
  },
  {
    id: 4,
    date: "2024-12-08",
    picture: {
      avif: "img/b4.avif",
      webp: "img/b4.webp",
      jpg: "img/b4.jpg",
    },
    title: "Fortune Tiger: Estratégias para Ganhar",
    descr:
      "Descubra as melhores estratégias para maximizar seus ganhos no emocionante Fortune Tiger.",
    fullText:
      "Fortune Tiger é um jogo que mistura sorte e estratégia. Aqui estão algumas dicas para ajudá-lo a vencer:\n\n1. Conheça os símbolos e suas combinações para entender melhor o jogo.\n\n2. Aproveite as rodadas grátis sempre que disponíveis para aumentar seus ganhos.\n\n3. Jogue de forma estratégica, ajustando suas apostas conforme necessário.\n\n4. Fique atento a promoções especiais no etropg que podem oferecer vantagens extras.\n\n5. Gerencie seu tempo e orçamento para jogar de forma responsável.\n\nFortune Tiger é uma excelente maneira de se divertir enquanto desafia sua sorte.\n\nCombinando essas estratégias com a experiência imersiva do jogo, suas chances de ganhar aumentam significativamente.\n\nExperimente agora e veja como o tigre da fortuna pode mudar seu destino!",
  },
  {
    id: 5,
    date: "2024-12-05",
    picture: {
      avif: "img/b5.avif",
      webp: "img/b5.webp",
      jpg: "img/b5.jpg",
    },
    title: "Por Que Escolher o etropg?",
    descr:
      "Descubra por que o etropg é a plataforma ideal para sua experiência de jogo online.",
    fullText:
      "O etropg se destaca por várias razões. Aqui estão alguns motivos para escolher esta plataforma:\n\n1. Variedade: Uma ampla gama de jogos para todos os gostos e estilos.\n\n2. Bônus: Ofertas exclusivas que aumentam suas chances de ganhar.\n\n3. Segurança: Proteção avançada para garantir sua privacidade e segurança financeira.\n\n4. Acessibilidade: Disponível em dispositivos móveis e desktops para sua conveniência.\n\n5. Suporte: Atendimento ao cliente disponível 24/7 para ajudá-lo sempre que necessário.\n\nAlém disso, o etropg é constantemente atualizado com novos jogos e funcionalidades para melhorar sua experiência.\n\nNão importa se você é iniciante ou experiente, o etropg tem algo especial para você.\n\nExplore o etropg hoje e descubra por que é a escolha número 1 para jogadores em todo o mundo!",
  },
];

const phone = () => {
  const html = document.querySelector("html");
  const header = document.querySelector(".header");
  const mobile = header.querySelector(".phone");
  const navEl = header.querySelector(".header__nav");
  let timeOut;

  const closephone = (time = 400) => {
    mobile.classList.remove("phone_active");

    navEl.classList.add("header__nav_show");
    navEl.classList.remove("header__nav_active");
    header.classList.remove("header_active");

    html.style.removeProperty("overflow");

    timeOut = setTimeout(() => {
      navEl.classList.remove("header__nav_show");
      navEl.style.removeProperty("top");
      navEl.style.removeProperty("height");
    }, time);
  };

  if (window.innerWidth > 1440) {
    closephone(0);
  }

  mobile.onclick = () => {
    clearTimeout(timeOut);

    if (mobile.classList.contains("phone_active")) {
      closephone();
      return;
    }

    html.style.overflow = "hidden";
    window.scrollTo(0, 0);

    mobile.classList.add("phone_active");
    header.classList.add("header_active");

    navEl.style.top = `${header.clientHeight}px`;
    navEl.style.height = `calc(var(--vh) - ${header.clientHeight}px)`;
    navEl.classList.add("header__nav_show");

    setTimeout(() => {
      navEl.classList.add("header__nav_active");
      navEl.classList.remove("header__nav_show");
    }, 0);
  };
};

const getVisible = (el) => {
  const rect = el.getBoundingClientRect();
  const windowHeight =
    window.innerHeight || document.documentElement.clientHeight;

  const vertInView =
    rect.top <= windowHeight - 50 && rect.top + rect.height >= 0;

  return vertInView;
};

const handleAnim = (collection, t = 0.4, d = 4) => {
  let order = 0;
  collection.forEach((item) => {
    if (item.classList.contains("anim_show")) return;

    if (!getVisible(item)) return;

    item.classList.add("anim_show");
    item.style.setProperty("--t", `${t}s`);
    item.style.setProperty("--d", `${(order * t) / d}s`);
    order++;
  });
};

const animColl = document.querySelectorAll(".anim");
const animFunc = () => {
  if (!animColl) return;
  handleAnim(animColl);
};
animFunc();

const handleSpecPromo = (block) => {
  const wrapper = document.querySelector(".footer__special");

  const changeHeight = () => {
    const height = block.clientHeight;

    if (height === wrapper.clientHeight) return;

    wrapper.style.height = `${height}px`;
  };

  changeHeight();

  window.addEventListener("resize", () => {
    changeHeight();
  });

  const onVisible = () => {
    const isVisible = getVisible(wrapper);

    if (!isVisible) {
      block.classList.add("specialPromo_sticky");
      return;
    }

    if (!block.classList.contains("specialPromo_sticky")) return;

    block.style.width = `${wrapper.clientWidth}px`;
    setTimeout(() => {
      block.classList.remove("specialPromo_sticky");
      block.removeAttribute("style");
    }, 0);
  };

  window.addEventListener("scroll", () => {
    onVisible();
  });

  onVisible();
};

const handleActivePage = () => {
  const url = window.location.pathname;

  const menuLinks = document.querySelectorAll(".menu__link");
  const currLink = [...menuLinks].find((link) => link.href.includes(url));

  if (!currLink) return;

  const menuItem = currLink.closest(".menu__item");
  menuItem.classList.add("menu__item_active");

  currLink.onclick = (e) => {
    e.preventDefault();
  };
};

const onAnimPromo = (block) => {
  const icons = block.querySelectorAll(".specialPromo__icon");

  icons.forEach((icon, i) => {
    const maxScale = 120;
    const minScale = 90;
    let step = 0.7;
    let progress = 100;
    function animIncr() {
      progress += step;
      icon.style.scale = progress / 100;

      if (progress >= maxScale) return requestAnimationFrame(animDecr);

      requestAnimationFrame(animIncr);
    }

    function animDecr() {
      progress -= step;
      icon.style.scale = progress / 100;

      if (progress <= minScale) return requestAnimationFrame(animIncr);

      requestAnimationFrame(animDecr);
    }

    setTimeout(() => {
      requestAnimationFrame(animIncr);
    }, i * 500);
  });
};

class Blog {
  constructor() {
    this.blogs = JSON.parse(localStorage.getItem("blogs"));

    if (!this.blogs) {
      this.setBlogs();
    }
  }

  setBlogs() {
    const newBlogs = blogs.map((blog, i) => {
      const date = new Date();
      date.setDate(date.getDate() - Math.floor(Math.random() * 14));
      date.setMonth(date.getMonth() - i);

      const dd = date.getDate();
      const mm = date.getMonth() + 1;
      const yy = date.getFullYear();
      blog.date = `${yy}-${mm}-${dd}`;

      return blog;
    });

    localStorage.setItem("blogs", JSON.stringify(newBlogs));
    this.blogs = newBlogs;
  }

  getBlogs() {
    return this.blogs;
  }

  setList(wrapper) {
    const template = wrapper.querySelector("#blog");
    this.blogs.forEach((data) => {
      this.setListItem(wrapper, template, data);
    });
  }

  setListItem(wrapper, template, data) {
    const card = template.content.cloneNode(true);

    const img = card.querySelector(".blog__img");
    img.src = data.picture.jpg;

    const picture = card.querySelector(".blog picture");

    if (data.picture.avif) {
      const source = document.createElement("source");
      source.srcset = data.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (data.picture.webp) {
      const source = document.createElement("source");
      source.srcset = data.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = card.querySelector(".blog__date");
    dateEl.dateTime = data.date;
    dateEl.textContent = this.getDate(data.date);

    const title = card.querySelector(".blog__title");
    title.textContent = data.title;

    const descr = card.querySelector(".blog__descr");
    descr.textContent = data.descr;

    const url = card.querySelector(".blog__url");
    url.href = `blog-detail.html?id=${data.id}`;

    wrapper.appendChild(card);
  }

  getDate(dateString) {
    const date = new Date(dateString);

    const dd = date.getDate().toString().padStart(2, "0");
    const mm = (date.getMonth() + 1).toString().padStart(2, "0");
    const yy = date.getFullYear();

    return `${dd}.${mm}.${yy}`;
  }

  setDetail(wrapper) {
    const params = new URLSearchParams(window.location.search);
    const id = parseInt(params.get("id"));

    if (!id) {
      window.location.assign("blog.html");
    }

    const blog = this.blogs.find((item) => item.id === id);

    if (!blog) {
      window.location.assign("blog.html");
    }

    const headTitle = document.querySelector("title");
    if (headTitle) headTitle.textContent = blog.title;

    const metaDescr = document.querySelector('meta[name="description"]');
    if (metaDescr) metaDescr.content = blog.descr;

    const template = wrapper.querySelector("#blog");
    const block = template.content.cloneNode(true);

    const img = block.querySelector(".blogDetail__img");
    img.src = blog.picture.jpg;

    const picture = block.querySelector("picture");

    if (blog.picture.avif) {
      const source = document.createElement("source");
      source.srcset = blog.picture.avif;
      (source.type = "image/avif"), picture.insertBefore(source, img);
    }

    if (blog.picture.webp) {
      const source = document.createElement("source");
      source.srcset = blog.picture.webp;
      (source.type = "image/webp"), picture.insertBefore(source, img);
    }

    const dateEl = block.querySelector(".blogDetail__date");
    dateEl.dateTime = blog.date;
    dateEl.textContent = this.getDate(blog.date);

    const title = block.querySelector(".blogDetail__title");
    title.textContent = blog.title;

    const descr = block.querySelector(".blogDetail__descr");
    descr.textContent = blog.descr;

    const content = block.querySelector(".blogDetail__content");
    content.innerHTML = blog.fullText.replaceAll("\n", "<br>");

    wrapper.appendChild(block);
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const accordionColl = document.querySelectorAll(".accord");
  accordionColl.forEach((item) => {
    const accordion = item;

    const closeAccord = (accord, wrapper, answer) => {
      wrapper.style.height = `${answer.clientHeight}px`;

      setTimeout(() => {
        wrapper.style.height = "0px";
        accord.classList.remove("accord_active");
      }, 0);

      setTimeout(() => {
        wrapper.removeAttribute("style");
        accord.classList.remove("accord_active");
      }, 400);
    };

    accordion.onclick = () => {
      const wrapper = accordion.querySelector(".accord__wrapper");
      const answer = accordion.querySelector(".accord__content");

      if (accordion.classList.contains("accord_active")) {
        closeAccord(accordion, wrapper, answer);
        return;
      }

      const currActive = document.querySelector(".accord_active");
      if (currActive) {
        const activeWrapper = currActive.querySelector(".accord__wrapper");
        const activeAnswer = currActive.querySelector(".accord__content");
        closeAccord(currActive, activeWrapper, activeAnswer);
      }

      wrapper.style.height = `${answer.clientHeight}px`;

      accordion.classList.add("accord_active");
      setTimeout(() => {
        wrapper.removeAttribute("style");
      }, 400);
    };
  });

  const blogsSec = document.querySelector(".blogs");
  if (blogsSec) {
    const blog = new Blog();
    const wrapper = blogsSec.querySelector(".blogs__list");
    blog.setList(wrapper);
  }

  const blogSec = document.querySelector(".blogDetail");
  if (blogSec) {
    const blog = new Blog();
    const wrapper = blogSec.querySelector(".blogDetail__wrapper");
    blog.setDetail(wrapper);
  }

  const specPromo = document.querySelector(".specialPromo");
  if (specPromo) {
    handleSpecPromo(specPromo);
  }

  const years = document.querySelectorAll(".year");
  if (years) {
    const date = new Date();
    const yy = date.getFullYear();

    years.forEach((year) => {
      year.textContent = yy;
    });
  }

  const promo = document.querySelector(".specialPromo");
  if (promo) {
    onAnimPromo(promo);
  }

  handleActivePage();

  phone();

  window.onresize = () => {
    phone();
    animFunc();
  };

  window.onscroll = () => {
    animFunc();
  };

  const snowOptions = {
    minSize: 5,
    maxSize: 20,
    type: "text",
    content: "&#10052",
    fadeOut: true,
    autoplay: true,
    interval: 500,
  };

  const snow = new Snowfall(snowOptions);
});
